var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"created-by"},[_vm._v(_vm._s(_vm.createdBy))]),(_vm.category && _vm.createdTime)?_c('p',{staticClass:"subhead"},[_vm._v(" "+_vm._s(_vm.category)+" • "+_vm._s(_vm.createdTime ? _vm.$dateUtils.formatDateTime(_vm.createdTime) : "")+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }